export const globalEnvironment = window["env"][window["env"]["envName"]];